<template>  
  <component :is="typeComponent" v-bind="$attrs" :value="value" @input="inputValue" :isLat="isLat" />
</template>
<script lang="ts">        
  import Vue from 'vue'  
  import Component from 'vue-class-component'  
  import LatLngEPSG4326Field from './LatLngEPSG4326Field.vue'
  import LatLngGliderField from './LatLngGliderField.vue'
  import LatLngHdmsField from './LatLngHdmsField.vue'

  @Component({
    name: 'LatLngField',  
    props:{                          
      value:{
        type:Number,
        default:0
      },
      format:{
        type:String,
        default:"formatEPSG4326ToHDMS"
      },
      isLat:{
        type:Boolean,
        default:true,
        required:true
      }
    },
    components:{LatLngEPSG4326Field,LatLngGliderField,LatLngHdmsField}
  })
  export default class LatLngField extends Vue {  
        
    private value!:number      
    private isLat!:boolean
    private format!:string

    get typeComponent(){
      return this.format == 'formatEPSG4326ToGlider'?'LatLngGliderField':
             this.format == 'formatEPSG4326ToHDMS'?'LatLngHdmsField':
             'LatLngEPSG4326Field'
    }

    inputValue(newV:any) {
      if(isNaN(newV)) this.$emit('input',0)
      this.$emit('input',newV)
    }
  }
</script>
